import __request__ from "routing/request";
export function getQueryDurationHistogram(requestOptions) {
  return __request__("GET", "/system/monitoring/query_duration_histogram", null, {}, {
    "Accept": [
      "application/json",
      "text/csv"
    ]
  }, requestOptions);
}
